import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { TopManagerLeaderDto } from '@sr/dto';
import { GridLayout } from 'shared/ui/grid-layout';
import PriceSpan from 'shared/ui/price-span';
import { useTopManager } from './top-manager.hook';

export const TopManagerGrid = ({ year, month }: { year: number; month: number }) => {
  const { collection, isLoading, error } = useTopManager({ year, month });

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Топ менеджеров по чистой прибыли</Typography>
      <TopManagerTable items={collection} isLoading={isLoading} error={error} showProfit />
    </Box>
  );
};

type Props = {
  items: (TopManagerLeaderDto & { totalProfit?: number })[];
  isLoading: boolean;
  error?: string;
  showProfit?: boolean;
};

const medals = ['🥇', '🥈', '🥉'];

export const TopManagerTable = ({ items, isLoading, error, showProfit = false }: Props) => (
  <GridLayout
    columns={showProfit ? ['Место', 'Менеджер', { label: 'Чистая прибыль', align: 'right' }] : ['Место', 'Менеджер']}
    items={items}
    isLoading={isLoading}
    error={error}
    height="auto"
    minHeight={0}
    noItemsText="Нет менеджеров с положительной чистой прибылью за выбранный период"
    itemRender={(row, index) => (
      <TableRow key={index}>
        <TableCell>{index + 1} {medals[index]}</TableCell>
        <TableCell>{row.fullName}</TableCell>
        {showProfit && <TableCell align="right"><PriceSpan price={row.totalProfit ?? 0} /></TableCell>}
      </TableRow>
    )}
  />
);
